import { axiosClient } from "services/axios";

import {
  GetEmployeesParams,
  ReassignWorkerParams,
  AddEmployeeParams,
  EditEmployeeParams,
} from "../types";

export function getEmployees({
  page = 1,
  pageSize = 100,
  group_id = null,
}: GetEmployeesParams) {
  return axiosClient
    .get("users/workers", { params: { page, pageSize, group_id } })
    .then((res) => res.data);
}

export function deleteEmployee(usersid: string | number) {
  return axiosClient.post("users/delete-worker", {
    usersid: Number(usersid),
  });
}

export function reassignWorker(params: ReassignWorkerParams) {
  return axiosClient.put("users/reassign-worker", params);
}

export function addEmployee(params: AddEmployeeParams) {
  return axiosClient.post("users/create-worker", params);
}

export function editEmployee(params: EditEmployeeParams) {
  return axiosClient.put("users/update-worker", params);
}
